import { SITE } from '../data/fleet'

/* Fixed to the bottom on phones. Most visits come from a job site. */
export default function CallBar() {
  return (
    <div className="callbar">
      <a href={SITE.phoneHref}>Call now</a>
      <a href="/#contact">Contact</a>
    </div>
  )
}
